import { render } from "./ListView.vue?vue&type=template&id=4f06443a&scoped=true"
const script = {}

import "./ListView.vue?vue&type=style&index=0&id=4f06443a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f06443a"]])

export default __exports__